
<!-- <app-list [type]="type" [items]="course?.chapters"></app-list> -->
<div *ngFor="let chapter of course?.chapters" class="row justify-content-center">
    <div class="col-xl-12">
        <app-curriculum-card [type]="type" [course]="currentCourse" [chapter]="chapter" *ngIf="type=='curriculum'||type=='course_menu'"></app-curriculum-card>
    </div>
</div>
